import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SupplementaryTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('SupplementaryTypeReference');
  }
}
